export default __webpack_public_path__ + "static/media/profile.f1d3e6df.png";